<!-- - AUDIO-->
<div
  class="event-log-box"
  [id]="'log-box-' + log.id"
  [class.is-select]="log.isSelected"
  [class.is-warning]="parseWarningLog()"
  (mouseenter)="onHoverLog($event, log.id)"
  (mouseleave)="onMouseLeaveLog($event, log)"
>
  <div class="event-log-action-box">
    <div class="audio-action-box audio-background" (click)="toggleAudioPlay($event)">
      <audio
        #audioControl
        (ended)="stopAudio()"
        (loadedmetadata)="loadMetadata()"
        (timeupdate)="updateProgress()"
      ></audio>
      <div class="loader absolute log-loader" *ngIf="isAudioLoading">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path log-stroke-color"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="4"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
      <ng-container *ngIf="!isAudioLoading">
        <div class="audio-action-duration-box" #audioProgressBar></div>
        <div class="v-center" style="justify-content: center; height: 100%">
          <i class="material-icons audio-icons" style="color: #c34a36; font-size: 32px">mic</i>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="event-log-metadata">
    <div class="flex" style="gap: 6px; flex-direction: column">
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="event-log-metadata-time">{{ log.eventCreated }}</div>
        <div class="event-log-metadata-category v-center" style="gap: 8px; flex-wrap: wrap">
          <div class="badge audio-background" *ngIf="!log?.isAutomation">Manual Audio Event</div>
          <div class="badge automation" *ngIf="log?.isAutomation">Automation Action</div>
        </div>
        <div
          class="--g-tooltip-content"
          *ngIf="parseWarningLog()"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
        >
          <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'rgb(205, 61, 100)'"></comp-icon>
          <div class="--g-tooltip" style="text-transform: none">
            This event includes data that could not be transmitted to the monitoring station.
          </div>
        </div>
      </div>
      <div class="v-center" style="gap: 8px; flex-wrap: wrap">
        <ng-container *ngFor="let list of log.eventCodeList">
          <div
            class="--g-tooltip-content"
            (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
            style="margin: 0"
          >
            <div class="badge xml-code">{{ list.code }}</div>
            <div class="--g-tooltip tooltip-background">XML Code</div>
          </div>
        </ng-container>
      </div>
      <div class="event-log-metadata-device">
        <div class="event-log-metadata-device-name" [class.no-name]="!log.name">{{ log.name ?? "No Name" }}</div>
        <div class="event-log-metadata-device-name">{{ formatAudioLabel() }}</div>
      </div>
      <div style="font-size: 14px">{{ log.status_text }}</div>
      <div *ngIf="log?.partnerDescription" style="font-size: 14px">{{ log?.partnerDescription }}</div>
    </div>
    <div class="event-log-metadata-id">
      <span *ngIf="log?.event_id">ID {{ log.event_id }}</span>
      <span *ngIf="log?.partnerEventId"> | Partner ID {{ log.partnerEventId }}</span>
    </div>
    <!-- SLOT : toolbar-->
    <ng-container *ngTemplateOutlet="toolbar; context: { log: log }"></ng-container>
  </div>
</div>
